import React from "react";
import { X, Sparkles, Music2, Crown } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function WelcomeModal() {
  const { welcomeOpen, setWelcomeOpen, artist, setAuthOpen } = useApp();
  if (!welcomeOpen) return null;

  return (
    <div className="fixed inset-0 z-[85] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={() => setWelcomeOpen(false)} />
      <div className="relative z-10 w-full max-w-[400px] rounded-3xl overflow-hidden border border-white/10 bg-[#101012]">
        <div className="relative h-36">
          <img src={artist.heroImage} alt={artist.name} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#101012] via-[#101012]/40 to-transparent" />
          <button onClick={() => setWelcomeOpen(false)} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/40 flex items-center justify-center hover:bg-black/60">
            <X size={16} />
          </button>
          <img src="/brand/s71-logo-sm.png" alt="S71" className="absolute top-3 left-3 h-6 w-auto object-contain" />
        </div>

        <div className="px-6 pb-6 -mt-4 relative">
          <span className="inline-flex items-center gap-1 text-[10px] tracking-[0.16em] uppercase text-[#a98bff] bg-[#8b5cf6]/15 px-2 py-0.5 rounded-full">
            <Sparkles size={11} /> You're invited
          </span>
          <h2 className="font-cond font-bold text-[24px] text-white mt-2 leading-tight">
            Welcome to {artist.name}'s official portal
          </h2>
          <p className="text-[13px] text-white/55 mt-2 leading-relaxed">
            This is the home of {artist.name} on S71 — own the music directly, watch exclusive videos,
            and unlock members-only content. 100% artist-owned, direct to you.
          </p>

          <div className="mt-4 space-y-2">
            <div className="flex items-center gap-2 text-[13px] text-white/70"><Music2 size={15} className="text-[#8b5cf6]" /> Buy & keep singles forever</div>
            <div className="flex items-center gap-2 text-[13px] text-white/70"><Crown size={15} className="text-amber-400" /> Join for live streams & early drops</div>
          </div>

          <button onClick={() => setWelcomeOpen(false)} className="mt-5 w-full h-12 rounded-full bg-white text-black text-[14px] font-semibold hover:bg-white/85">
            Explore the portal
          </button>
          <button onClick={() => { setWelcomeOpen(false); setAuthOpen(true); }} className="mt-2 w-full h-11 rounded-full text-[13px] text-[#a98bff] hover:bg-white/5">
            Create a free account for exclusive content
          </button>
        </div>
      </div>
    </div>
  );
}
